import { Controller } from '@hotwired/stimulus'
import { computePosition, autoUpdate, flip, shift, offset } from '@floating-ui/dom'

export default class extends Controller {
  static targets = ['search', 'tag', 'noResults', 'anchor', 'menu']
  static values = { closeUrl: String }

  connect() {
    this.query = ''
    if (this.hasSearchTarget) {
      this.searchTarget.focus()
    }
    this.setupFloatingMenu()
    this.handleOutsideClick = this.handleOutsideClick.bind(this)
    this.handleKeydown = this.handleKeydown.bind(this)
    document.addEventListener('click', this.handleOutsideClick)
    document.addEventListener('keydown', this.handleKeydown)
  }

  disconnect() {
    document.removeEventListener('click', this.handleOutsideClick)
    document.removeEventListener('keydown', this.handleKeydown)
    if (this.stopFloatingMenu) {
      this.stopFloatingMenu()
      this.stopFloatingMenu = null
    }
  }

  setupFloatingMenu() {
    if (!this.hasMenuTarget || !this.hasAnchorTarget) return

    this.stopFloatingMenu = autoUpdate(
      this.anchorTarget,
      this.menuTarget,
      () => this.updateFloatingMenuPosition(),
      { ancestorScroll: true, ancestorResize: true, elementResize: true }
    )
    this.updateFloatingMenuPosition()
  }

  async updateFloatingMenuPosition() {
    const { x, y } = await computePosition(this.anchorTarget, this.menuTarget, {
      placement: 'bottom-start',
      strategy: 'fixed',
      middleware: [
        offset(4),
        flip({ fallbackPlacements: ['top-start', 'bottom-start'] }),
        shift({ padding: 8 })
      ]
    })

    Object.assign(this.menuTarget.style, {
      position: 'fixed',
      left: `${x}px`,
      top: `${y}px`,
      zIndex: '1300',
      visibility: 'visible'
    })
  }

  handleOutsideClick(event) {
    const frame = this.element.closest('turbo-frame')
    if (frame && !frame.contains(event.target)) {
      this.close()
    }
  }

  handleKeydown(event) {
    if (event.key === 'Escape') this.close()
  }

  close() {
    if (!this.hasCloseUrlValue) return
    const frame = this.element.closest('turbo-frame')
    if (frame) frame.src = this.closeUrlValue
  }

  filter(event) {
    const query = event.target.value.trim().toLowerCase()
    let visibleCount = 0

    this.tagTargets.forEach(el => {
      const name = (el.dataset.tagName || '').toLowerCase()
      const matches = !query || name.includes(query)
      el.style.display = matches ? '' : 'none'
      if (matches) visibleCount++
    })

    if (this.hasNoResultsTarget) {
      this.noResultsTarget.style.display = visibleCount === 0 && query ? '' : 'none'
    }
  }
}
